import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../../utils/api';
import BottomNav from '../../../components/layout/BottomNav';
import BackButton from '../../../components/common/BackButton';

const G     = '#166534';
const LIGHT = '#DCFCE7';

// listingType can be 'rent', 'lease', or 'sale' — rent/lease are shown "/Month"
const TYPE_META = {
  rent:  { label:'Rent',  color:G },
  lease: { label:'Lease', color:G },
  sale:  { label:'Sale',  color:'#EA580C' },
};
const isRecurring = (t) => t === 'rent' || t === 'lease';

export default function LandListingsPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [listings, setListings] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [liked,    setLiked]    = useState({});
  const initialType = searchParams.get('type');
  const [tab, setTab] = useState(['rent', 'lease', 'sale'].includes(initialType) ? initialType : 'lease');

  const category = searchParams.get('category') || '';
  const search   = searchParams.get('search') || '';

  useEffect(() => { loadListings(); }, [tab]); 

  const loadListings = async () => {
    setLoading(true);
    try {
      let url = `/land?type=${tab}&limit=50`;
      if (category) url += `&category=${encodeURIComponent(category)}`;
      if (search)   url += `&search=${encodeURIComponent(search)}`;
      const { data } = await api.get(url);
      setListings(data.listings || data.data || []);
    } catch { setListings([]); }
    finally { setLoading(false); }
  };

  const switchTab = (t) => {
    setTab(t);
    const next = new URLSearchParams(searchParams);
    next.set('type', t);
    setSearchParams(next);
  };

  const clearCategory = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('category');
    setSearchParams(next);
  };

  return (
    <div style={{ background:'#F5F7FA', minHeight:'100vh', fontFamily:'Inter,system-ui,sans-serif', paddingBottom:90 }}>

      {/* Header */}
      <div style={{ background:G, padding:'14px 16px 14px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <BackButton />
          <div style={{ fontSize:17, fontWeight:700, color:'white' }}>Land Listings</div>
          <div style={{ width:34, height:34, borderRadius:'50%', background:'rgba(255,255,255,.2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, color:'white', fontWeight:700 }}>
            {listings.length}
          </div>
        </div>
      </div>

      {/* Rent / Lease / Sale tabs */}
      <div style={{ display:'flex', gap:8, padding:'14px 14px 0' }}>
        {[{ key:'rent', label:'Rent' }, { key:'lease', label:'Lease' }, { key:'sale', label:'Sale' }].map(t => (
          <button key={t.key} onClick={() => switchTab(t.key)}
            style={{
              flex:1, padding:'10px', borderRadius:12, fontSize:13, fontWeight:700, cursor:'pointer',
              border:`1.5px solid ${tab===t.key ? G : '#E5E7EB'}`,
              background: tab===t.key ? G : 'white',
              color: tab===t.key ? 'white' : '#6B7280',
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {category && (
        <div style={{ padding:'12px 14px 0' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:LIGHT, color:G, border:'1px solid #BBF7D0', borderRadius:20, padding:'6px 8px 6px 14px', fontSize:12, fontWeight:700 }}>
            Category: {category}
            <button onClick={clearCategory}
              style={{ width:20, height:20, borderRadius:'50%', border:'none', background:'white', color:G, fontSize:13, fontWeight:700, cursor:'pointer' }}>×</button>
          </div>
        </div>
      )}

      <div style={{ padding:'14px 14px 0' }}>
        {loading ? (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {[1,2,3].map(i => <div key={i} style={{ height:110, background:'white', borderRadius:16, opacity:.5 }} />)}
          </div>
        ) : listings.length === 0 ? (
          <div style={{ textAlign:'center', padding:'50px 0', color:'#9CA3AF' }}>
            <div style={{ fontSize:44, marginBottom:10 }}></div>
            <div style={{ fontSize:14 }}>No {tab} listings found yet</div>
            <button onClick={() => navigate('/land/add')}
              style={{ marginTop:14, background:G, color:'white', border:'none', borderRadius:10, padding:'9px 18px', fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
              + Add Property
            </button>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {listings.map(item => (
              <div key={item._id} onClick={() => navigate(`/land/${item._id}`)}
                style={{ background:'white', borderRadius:16, border:'0.5px solid #E5E7EB', display:'flex', gap:10, padding:8, boxShadow:'0 2px 8px rgba(0,0,0,.04)', cursor:'pointer' }}>
                <div style={{ position:'relative', width:96, height:96, borderRadius:12, overflow:'hidden', background:LIGHT, flexShrink:0 }}>
                  {item.photos?.[0] && <img src={item.photos[0]} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
                  <span style={{
                    position:'absolute', top:6, left:6, fontSize:10, fontWeight:700, color:'white', padding:'2px 8px', borderRadius:6,
                    background: (TYPE_META[item.listingType] || TYPE_META.sale).color,
                  }}>
                    {(TYPE_META[item.listingType] || TYPE_META.sale).label}
                  </span>
                </div>
                <div style={{ flex:1, paddingTop:2 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                    <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a' }}>{item.title}</div>
                    <button onClick={e => { e.stopPropagation(); setLiked(p => ({ ...p, [item._id]: !p[item._id] })); }}
                      style={{ background:'none', border:'none', cursor:'pointer', fontSize:15, color: liked[item._id] ? '#EF4444' : '#D1D5DB' }}>
                      ♥
                    </button>
                  </div>
                  <div style={{ fontSize:11, color:'#9CA3AF', margin:'4px 0' }}> {item.address}</div>
                  <div style={{ fontSize:13, fontWeight:700, color:G }}>
                    ₹{item.price?.toLocaleString?.() || item.price}
                    {isRecurring(item.listingType) && <span style={{ fontSize:10, color:'#9CA3AF', fontWeight:400 }}> / Month</span>}
                  </div>
                  <div style={{ fontSize:10, color:'#9CA3AF', marginTop:2 }}>{item.area} {item.areaUnit} · {item.landType}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}